import React from "react"

import { LANGUAGE } from "actions/constants"

export default {
    [LANGUAGE.EN]: [
        {
            Question: () => <>Do you have a registry?</>,
            Answer: () => <>We do not have a registry as your presence is our greatest gift.
                            You've already gone out of your way to travel to be with us on our special day;
                            that would be the most precious memory ever.</>,
        },
/*        {
            Question: () => <>What is the plan for the group day trip on Oct 27?</>,
            Answer: () => (
                <>
                    We will have vans picking people up from the venue (Kaomai Lanna Resort) 
around noon to explore some temples and cool spots outside the city.
                    More details will be posted soon.
                </>
            ),
        },*/
        {
            Question: () => <>What languages the wedding ceremony is going to be?</>,
            Answer: () => (
                <>
                    Partying and laughing is its own language that anyone can speak.
                    But half of our guests speak Mandarin (some 
of them also know English), and half of our guests speak English and other languages.
                    So we plan on having translation technology set up 
                    for during the ceremony (pressure is on Brian).
                </>
            ),
        },
        {
            Question: () => <>What is the dress code?</>,
            Answer: () => (
                <>
                    The wedding will be semi-formal. We recommend 
                    dresses and suits. White is
                    reserved for the bride. For the rehersal dinner casual
                    attire is preferred.
                </>
            ),
        },
        {
            Question: () => <>What is the weather like?</>,
            Answer: () => (
                <>
                    The weather during this time of year is usually sunny and in
                    the high 80s during the day and 70s at night (ºF).
                </>
            ),
        },
    ],
    [LANGUAGE.ZH]: [
        /*{
            Question: () => <>婚礼前一天（10月27日）的团游是如何安排的?</>,
            Answer: () => 
<>当天中午会有车从婚礼场（高迈兰纳度假村）出发，带大家去市区外的一些寺庙和有趣的地方走走看看。更多细节，敬请期待！</>,
        },*/
        {
            Question: () => (
                <>
                    婚礼会是什么语言?
                </>
            ),
            Answer: () => (
                <>
                    狂欢和大笑是每个人都有的共同语言. 
但我们的来宾大概一半说中文（其中一些也讲英文），
一半说英文和其他语言。我们打算在婚礼仪式中，使用实时翻译软件，
可以给大家带来更好的体验（Brian在努力中💪）                </>
            ),
        },
        {
            Question: () => <>有着装要求吗?</>,
            Answer: () => (
                <>
                    
婚礼是半正式着装要求。我们推荐裙子和西装，颜色不限，但白色留给新娘。
对于10月27日的欢迎晚宴，我们推荐休闲穿搭。
                </>
            ),
        },
        {
            Question: () => <>届时清迈的天气如何?</>,
            Answer: () => (
                <>
                   
十月底的清迈，天气通常比较凉爽，降雨相对较少。白天平均气温在25-28摄氏度左右，晚上会稍凉，可能会降到20摄氏度以下。
                </>
            
            ),
        },
    ],
}
